import { render, staticRenderFns } from "./MarketProducerProfile.vue?vue&type=template&id=75815299&"
import script from "./MarketProducerProfile.vue?vue&type=script&lang=js&"
export * from "./MarketProducerProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports